import { createStore, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "./reducers";

const initialState = {};
const middleware = [thunk];

// Simple transform to exclude only auth tokens but preserve user data for F5 refresh
const userTransform = {
  in: (inboundState, key) => {
    if (key === 'user') {
      // Be more defensive - handle different user data structures
      if (inboundState && inboundState.user) {
        // Keep all user data but exclude auth tokens that shouldn't persist across sessions
        const { 
          auth_token, 
          access_token, 
          refresh_token,
          session_id,
          ...persistableData 
        } = inboundState.user;
        
        // Only transform if we have actual user data to preserve
        if (Object.keys(persistableData).length > 0) {
          return {
            user: persistableData
          };
        }
      }
    }
    return inboundState;
  },
  out: (outboundState, key) => {
    return outboundState;
  }
};

const persistConfig = {
  key: "root",
  storage,
  transforms: [userTransform],
  version: 1
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = createStore(
  persistedReducer,
  initialState,
  compose(
    applyMiddleware(...middleware),
    window.__REDUX_DEVTOOLS_EXTENSION__
      ? window.__REDUX_DEVTOOLS_EXTENSION__()
      : a => a
  )
);

export const persistor = persistStore(store);

